import React from "react";
import "./Component_2.css";

const Component_2 = ({ title, features, imgSrc }) => {
  return (
    <div className="component-2">
      <div className="row">
        <div className="col-lg-9">
          <div className="left_div">
            <h2 className="div-title">{title}</h2>
            {features?.map((item) => {
              return (
                <div className="main-content-div">
                  <div className="left_logo">
                    {imgSrc && (
                      <img
                        src={process.env.PUBLIC_URL + item?.imgSrc}
                        className="logo"
                      />
                    )}
                  </div>

                  <div className="feature-div">
                    <p className="feature-label">
                      <span>{item?.label}</span>
                      {item?.value}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Component_2;
